import { useCallback } from 'react';

import { useLocalStorage } from './useLocalStorage';

const STORAGE_KEY = 'calmcycle:events-v1';

/**
 * Per-day plans/events ("Team meeting", "Wedding", "Dentist") stored
 * separately from symptom logs — plans exist for future days too.
 */
export function useCycleEvents() {
  const [raw, setRaw] = useLocalStorage<Record<string, string>>(STORAGE_KEY, {});

  // Guard against corrupted/partial stored values.
  const events: Record<string, string> =
    raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};

  const setEvent = useCallback(
    (date: string, text: string) => {
      const trimmed = text.trim();
      setRaw((prev) => {
        const next = { ...(prev ?? {}) };
        if (trimmed) next[date] = trimmed;
        else delete next[date];
        return next;
      });
    },
    [setRaw],
  );

  return { events, setEvent };
}
